import { useUI } from "@contexts/ui.context";
import { API_ENDPOINTS } from "@framework/utils/api-endpoints";
import http from "@framework/utils/http";
import { removeSiteCookie } from "@framework/utils/set-cookies";
import Router from "next/router";
import { useMutation } from "react-query";
async function logout() {
  const {
    data
  } = await http.post(API_ENDPOINTS.LOGOUT);
  return data;
}
export const useLogoutMutation = () => {
  const {
    unauthorize
  } = useUI();
  return useMutation(() => logout(), {
    onSuccess: _data => {
      removeSiteCookie("auth_token");
      removeSiteCookie("user");
      unauthorize();
      Router.push("/").then(() => window.location.reload());
    },
    onError: data => {
      console.log(data, "logout error response");
    }
  });
};